import { Joi } from 'app-webtech-core/schemas';
import { subselect } from './root';

const haveErrorDeviceStateSchemaValidator = Joi.object()
  .unknown()
  .keys({
    error: Joi.object().type(Error).required(),
  });

const assertSelector = (deviceState) => {
  const { error } = Joi.validate(deviceState, haveErrorDeviceStateSchemaValidator);
  return !error;
};

export const deviceHaveErrorSelector = subselect(assertSelector);
